// eslint-disable-next-line import/prefer-default-export
export const hasAlphaChannel = async (file) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const buffer = new Uint8Array(arrayBuffer);

    // Check PNG signature
    const PNG_SIGNATURE = [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A];
    const isValid = PNG_SIGNATURE.every((byte, i) => buffer[i] === byte);

    if (!isValid) {
      throw new Error('Not a valid PNG file');
    }

    // Byte 25 contains color type
    const colorType = buffer[25];

    // Color types: 4 = Grayscale+alpha, 6 = RGB+alpha
    if (colorType === 4 || colorType === 6) {
      return true;
    }

    // Color type 3 = indexed color, check for tRNS (transparency) chunk
    if (colorType === 3) {
      const view = new DataView(arrayBuffer);
      let offset = 33; // Start after IHDR chunk

      // Scan PNG chunks in header (limit to first 1KB)
      while (offset < buffer.length - 8 && offset <= 1000) {
        const chunkLength = view.getUint32(offset); // Read chunk size (4 bytes, big-endian)
        // Convert 4 bytes to ASCII chunk name (e.g., [116,82,78,83] → "tRNS")
        const chunkType = String.fromCharCode(...buffer.slice(offset + 4, offset + 8));

        if (chunkType === 'tRNS') return true; // Found transparency chunk
        if (chunkType === 'IDAT') break; // Image data reached, no more header chunks

        offset += 12 + chunkLength; // Skip to next chunk (length + type + CRC = 12 bytes + data)
      }
    }

    return false;
  } catch (err) {
    throw new Error(`Failed to read file: ${err.message}`);
  }
};
